import { menuRegistry } from '@/common/menu/menuRegistry';
import { registerRouteForModule } from '@/common/route/registerModules';
import router, { ROUTE_NAME_GOOGLE } from './router';

menuRegistry.registerMenu([
    {
        parent: 'ThirdParty',
        key: 'Google',
        name: 'Google',
        icon: 'fab fa-google'
    },
    {
        parent: 'ThirdParty.Google',
        key: 'Payment',
        name: 'Payment',
        icon: 'fas fa-money-bill-wave',
        route: { name: ROUTE_NAME_GOOGLE.PAYMENT }
    },
    {
        parent: 'ThirdParty.Google',
        key: 'Linkedapp',
        name: 'Linked app',
        icon: 'fas fa-link',
        route: { name: ROUTE_NAME_GOOGLE.LINKED_APP }
    }
]);

export default registerRouteForModule(router);
